const permissions = {
  conversations: 'WA001',
  sendMessages: 'WA002',
  editConversations: 'WA003',
  viewWhatsAppBusinessSettings: 'WA004',
  addWhatsAppBusinessSettings: 'WA005',
  editWhatsAppBusinessSettings: 'WA006'
};

export default permissions;
